import { createSleepFrames, createSleepZFrames } from "../../core/personality-keyframes.js";

export const meta = Object.freeze({
  id: "sleep",
  label: "Idle: Schlafen",
  duration: 5600,
  description: "Orbi schließt weich die Augen, atmet ruhig und lässt gestaffelte Zzz aufsteigen.",
  tags: ["body", "expression", "idle", "ambient", "sleep", "one-shot", "loopable"],
});

export async function run({ elements, scene, animate }) {
  if (!elements.sleepEyes || !scene?.sleepZs || scene.sleepZs.length !== 4) {
    throw new Error("Die Schlaf-Sequenz benötigt Schlafaugen und vier Z-Zeichen der Stage.");
  }
  const frames = createSleepFrames();
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.body, options),
    animate(elements.shadow, frames.shadow, options),
    animate(elements.eyes, frames.eyes, options),
    animate(elements.openEyes, frames.openEyes, options),
    animate(elements.sleepEyes, frames.sleepEyes, options),
    animate(elements.mouthWhistleClosed, frames.mouth, options),
    animate(elements.glow, frames.glow, options),
    ...scene.sleepZs.map((z, index) => animate(z, createSleepZFrames(index), options)),
  ];
  await Promise.allSettled(animations.map(({ finished }) => finished));
}
